<dt class="mb-2">
  Shift Preflight Checklist
  <span class="custom-button" (click)="redirectToMobileForms()"
    >Mobile Forms</span
  >
  <span
    class="ms-2"
    data-bs-toggle="tooltip"
    data-bs-placement="top"
    data-bs-title="Select a mobile form that you want your users to fill in before starting their shift."
  >
    <i class="fa-solid fa-circle-info text-success"></i>
  </span>
</dt>

<table class="table table-borderless">
  <tbody>
    @for (jType of availableJobTypes; track $index) {
      <tr>
        <td [vAlign]="'middle'">{{ jType?.name }}</td>

        <td>
          @if (preAssignedPrompts?.[jType?.id]?.name) {
            <div>
              {{ preAssignedPrompts?.[jType?.id]?.name }}
              <span
                class="del-button"
                (click)="
                  updatePreSafetyPrompt(
                    preAssignedPrompts?.[jType?.id],
                    jType,
                    true
                  )
                "
              ></span>
            </div>
          } @else {
            <gtapp-auto-complete
              [data]="userPromptDropDownList"
              placeHolder="Select Mobile Form"
              searchKeyword="name"
              [addInitialKey]="true"
              [itemTemplate]="userPromptLookupTemplate"
              (inputChanged)="onUserPromptLookup($event)"
              (selected)="updatePreSafetyPrompt($event, jType)"
            >
            </gtapp-auto-complete>
            <ng-template #userPromptLookupTemplate let-item>
              @if (item?.key === 0) {
                <div>Create New Form</div>
              } @else {
                <div>{{ item?.name }}</div>
              }
            </ng-template>
          }
        </td>
      </tr>
    }
  </tbody>
</table>
